"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var EventType_1 = require("../../model/types/EventType");
var Id_1 = require("../types/Id");
var AbstractEvent_1 = require("./AbstractEvent");
var ExchangeFinalizedEvent = (function (_super) {
    __extends(ExchangeFinalizedEvent, _super);
    function ExchangeFinalizedEvent(exchangeId) {
        var _this = _super.call(this) || this;
        _this.props = new ExchangeFinalizedEventProperties(new Id_1.Id(exchangeId));
        return _this;
    }
    ExchangeFinalizedEvent.prototype.getType = function () {
        return EventType_1.EventType.ExchangeFinalized;
    };
    return ExchangeFinalizedEvent;
}(AbstractEvent_1.AbstractEvent));
exports.ExchangeFinalizedEvent = ExchangeFinalizedEvent;
var ExchangeFinalizedEventProperties = (function () {
    function ExchangeFinalizedEventProperties(exchange_id) {
        this.exchange_id = exchange_id;
    }
    return ExchangeFinalizedEventProperties;
}());
//# sourceMappingURL=ExchangeFinalizedEvent.js.map